<template>
  <div>
    <h1>Active upload file shares</h1>
    <div>Upload file shares active on the system</div>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="uploadFileShares"
      v-if="uploadFileShares"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.code }}</td>
          <td>
            <FileGql :file="props.item.file" v-if="props.item.file" />
          </td>
          <td>{{ props.item.subject }}</td>
          <td>{{ props.item.expiresAt | formatDateTime }}</td>
          <td>
            <v-btn @click="resendUploadFileShare(props.item)" small>
              <v-icon>send</v-icon>Resend
            </v-btn>
            <v-btn @click="deleteUploadFileShare(props.item)" small>
              <v-icon>delete</v-icon>Delete
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import UPLOADFILESHARES from "@/graphql/document/UploadFileShares";
import RESEND_UPLOADFILESHARE from "@/graphql/document/ResendUploadFileShare";
import DELETE_UPLOADFILESHARE from "@/graphql/document/DeleteUploadFileShare";
import FileGql from "@/components/link/FileGql";
export default {
  name: "UnsentUploadFileShares",
  metaInfo() {
    return {
      title: "Active upload file shares",
      titleTemplate: "%s - Notifications - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    uploadFileShares: {
      query: UPLOADFILESHARES,
      fetchPolicy: "cache-and-network"
    }
  },
  components: { FileGql },
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Code",
          value: "code"
        },
        {
          text: "Reference",
          value: "file.referencelong"
        },
        {
          text: "Subject",
          value: "subject"
        },
        {
          text: "Expires at",
          value: "expiresAt"
        },
        {
          text: "Actions",
          sortable: false
        }
      ],
      pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 25
      }
    };
  },
  methods: {
    async resendUploadFileShare(uploadFileShare) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: RESEND_UPLOADFILESHARE,
          variables: {
            id: uploadFileShare.id
          },
          refetchQueries: [
            {
              query: UPLOADFILESHARES
            }
          ]
        });
      }
    },
    async deleteUploadFileShare(uploadFileShare) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: DELETE_UPLOADFILESHARE,
          variables: {
            id: uploadFileShare.id
          },
          refetchQueries: [
            {
              query: UPLOADFILESHARES
            }
          ]
        });
      }
    }
  }
};
</script>